"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPrettyPrintSimple = void 0;
var property_1 = require("@promaster-sdk/property");
var lib_cjs_1 = require("ts-exhaustive-check/lib-cjs");
function filterPrettyPrintSimple(f) {
    if (f.ast === null) {
        return "";
    }
    var result = "";
    result = _print(f.ast, result);
    return result;
}
exports.filterPrettyPrintSimple = filterPrettyPrintSimple;
function _print(e, s) {
    switch (e.type) {
        case "AndExpr": {
            for (var _i = 0, _a = e.children; _i < _a.length; _i++) {
                var child = _a[_i];
                s = _print(child, s);
                if (child !== e.children[e.children.length - 1]) {
                    s += " and ";
                }
            }
            break;
        }
        case "ComparisonExpr": {
            s = _print(e.leftValue, s);
            s += _comparisonOperationTypeToString(e.operationType);
            s = _print(e.rightValue, s);
            break;
        }
        case "EqualsExpr": {
            s = _print(e.leftValue, s);
            s += _equalsOperationTypeToString(e.operationType);
            for (var _b = 0, _c = e.rightValueRanges; _b < _c.length; _b++) {
                var range = _c[_b];
                s = _print(range, s);
                if (range !== e.rightValueRanges[e.rightValueRanges.length - 1]) {
                    s += ",";
                }
            }
            break;
        }
        case "IdentifierExpr": {
            s += e.name;
            break;
        }
        case "OrExpr": {
            for (var _d = 0, _e = e.children; _d < _e.length; _d++) {
                var child = _e[_d];
                s = _print(child, s);
                if (child !== e.children[e.children.length - 1]) {
                    s += " or ";
                }
            }
            break;
        }
        case "ValueRangeExpr": {
            s = _print(e.min, s);
            if (e.min !== e.max) {
                s += "-";
                s = _print(e.max, s);
            }
            break;
        }
        case "ValueExpr": {
            s += property_1.PropertyValue.toString(e.parsed);
            break;
        }
        case "NullExpr": {
            s += "null";
            break;
        }
        case "AddExpr": {
            s += _print(e.left, s) + " " + (e.operationType === "add" ? "+" : "-") + " " + _print(e.right, s);
            break;
        }
        case "MulExpr": {
            s += _print(e.left, s) + " " + (e.operationType === "multiply" ? "*" : "/") + " " + _print(e.right, s);
            break;
        }
        case "UnaryExpr": {
            s += "-" + _print(e.value, "");
            break;
        }
        case "EmptyExpr": {
            break;
        }
        default: {
            lib_cjs_1.exhaustiveCheck(e, true);
        }
    }
    return s;
}
function _comparisonOperationTypeToString(type) {
    switch (type) {
        case "lessOrEqual":
            return " must be less than or equal to ";
        case "greaterOrEqual":
            return " must be greater than or equal to ";
        case "less":
            return " must be less than ";
        case "greater":
            return " must be greater than ";
        default:
            throw new Error("Unknown ComparisonOperationType ");
    }
}
function _equalsOperationTypeToString(type) {
    switch (type) {
        case "equals":
            return " must be ";
        case "notEquals":
            return " must not be ";
        default:
            throw new Error("Unknown EqualsOperationType ");
    }
}
//# sourceMappingURL=filter-pretty-print-simple.js.map